import React, {useEffect, useRef, useState} from "react";

function pretty(obj) {
    return JSON.stringify(obj, null, 2);
}

export default function JsonAdvancedEditor({
                                               open,
                                               title = "JSON Editor",
                                               initialObject,
                                               schemaVersionExpected = 1,
                                               onApply,
                                               onClose,
                                           }) {
    const [text, setText] = useState("");
    const [error, setError] = useState("");
    const textareaRef = useRef(null);

    useEffect(() => {
        if (!open) return;

        setText(pretty(initialObject));
        setError("");

        setTimeout(() => {
            textareaRef.current?.focus();
        }, 0);
    }, [open, initialObject]);

    const validateAndParse = () => {
        setError("");

        try {
            const parsed = JSON.parse(text);

            if (
                !parsed ||
                typeof parsed !== "object" ||
                Array.isArray(parsed)
            ) {
                setError("JSON باید یک آبجکت باشد.");
                return null;
            }

            if (parsed.schemaVersion !== schemaVersionExpected) {
                setError(
                    `schemaVersion باید ${schemaVersionExpected} باشد.`
                );
                return null;
            }


            return parsed;
        } catch (e) {
            setError("JSON نامعتبر است: " + e.message);
            return null;
        }
    };

    const handleFormat = () => {
        try {
            const parsed = JSON.parse(text);

            setText(JSON.stringify(parsed, null, 2));
            setError("");
        } catch (e) {
            setError("JSON نامعتبر است: " + e.message);
        }
    };

    const handleApply = () => {
        const parsed = validateAndParse();

        if (!parsed) return;

        onApply(parsed);
        onClose();
    };

    if (!open) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center ltr justify-center bg-black/50 backdrop-blur">
            <div
                className="w-[980px] max-w-[96vw] rounded-2xl bg-[#0b0f14] border border-white/10 shadow-2xl overflow-hidden">

                {/* Header */}
                <div className="flex items-center justify-between px-4 py-3 border-b border-white/10">
                    <div className="text-white font-bold">
                        {title}
                    </div>

                    <div className="flex gap-2">
                        <button
                            onClick={handleFormat}
                            className="px-3 py-2 rounded-xl bg-white/10 hover:bg-white/15 text-white text-sm"
                        >
                            Format
                        </button>

                        <button
                            onClick={onClose}
                            className="px-3 py-2 rounded-xl bg-white/10 hover:bg-white/15 text-white text-sm"
                        >
                            Close
                        </button>
                    </div>
                </div>

                {/* Error */}
                {error && (
                    <div
                        className="mx-4 mt-3 p-3 rounded-xl bg-red-500/15 border border-red-500/30 text-red-200 text-sm">
                        {error}
                    </div>
                )}

                {/* Editor */}
                <div className="p-4">
                    <textarea
                        ref={textareaRef}
                        value={text}
                        onChange={(e) => {
                            setText(e.target.value);
                            setError("");
                        }}
                        spellCheck={false}
                        autoCorrect="off"
                        autoCapitalize="off"
                        wrap="off"
                        className="
                            ltr
                            w-full
                            h-[62vh]
                            resize-none
                            rounded-xl
                            border
                            border-white/10
                            bg-[#111820]
                            text-gray-200
                            p-4
                            font-mono
                            text-sm
                            leading-6
                            outline-none
                            focus:border-blue-500/50
                            focus:ring-1
                            focus:ring-blue-500/30
                            overflow-auto
                        "
                        style={{
                            tabSize: 2,
                        }}
                    />

                    {/* Buttons */}
                    <div className="flex justify-end gap-2 mt-4">
                        <button
                            onClick={onClose}
                            className="px-4 py-2 rounded-xl bg-white/10 hover:bg-white/15 text-white"
                        >
                            Cancel
                        </button>

                        <button
                            onClick={handleApply}
                            className="px-4 py-2 rounded-xl bg-blue-600 hover:bg-blue-700 text-white"
                        >
                            Apply
                        </button>
                    </div>

                    <div className="text-xs text-white/50 mt-2">
                        Edit the JSON directly, then press Format or Apply.
                    </div>
                </div>
            </div>
        </div>
    );
}